/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import { Button, Input, SimpleSelect } from 'components/atoms';
import { Modal } from 'components/molecules/Modal';
import { useGetExportTicket } from 'framework/api/methods';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setGenerateTokenModalShow } from 'store/reducers/user/userSlice';

export interface CategoriesProps {
  [x: string]: any;
}

export const Tickets: FC<CategoriesProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const { ticketList }: any = useSelector<any>((state) => state.user);
  const [isOpenViewModal, setIsOpenViewModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState('');

  const { mutate: getExportTicketMutate, isLoading: getExportTicketsLoading } =
    useGetExportTicket();

  const getExportTicket = () => {
    getExportTicketMutate(undefined, {
      onSuccess: ({ data: successData }: any) => {
        const blob = new Blob([successData]);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `tickets-report.xlsx`; // Customize the file name
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      onError: ({ response: { data: errData }, response }: any) => {
        if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
          notify('Session expired.', 'error');
          setTimeout(() => {
            navigate('/auth/login');
            localStorage.clear();
          }, 2000);
        } else {
          notify(errData?.message || 'Something went wrong.', 'error');
        }
      },
    });
  };

  return (
    <div className="flex justify-center items-start w-full h-full md:p-8 p-3 overflow-y-auto gap-x-5 gap-y-3 flex-col">
      <div className="flex justify-between items-center w-full">
        <div className="w-1/3">
          <Button
            appearance="secondary"
            onClick={() => {
              getExportTicket();
            }}
            isLoading={getExportTicketsLoading}
          >
            <i className="ri-upload-2-line pr-2" />
            Export
          </Button>
        </div>

        <div className="w-2/3 flex justify-end items-end">
          <Button
            size="sm"
            onClick={() => {
              dispatch(setGenerateTokenModalShow());
            }}
          >
            <i className="ri-add-line pr-1" />
            Generate Tickets
          </Button>
        </div>
      </div>

      <div className="w-full bg-white h-full rounded-[20px] md:p-5 p-3 overflow-y-auto">
        <div className="flex flex-col w-full">
          <div className="flex justify-between w-full text-[#7B1B67] pb-2 mb-1 border-b border-[#EDF2F6] font-medium">
            <div className="md:w-1/12 w-1/3 text-xs">Ticket ID</div>
            <div className="md:w-2/12 w-1/3 text-xs text-start">Date & Time</div>
            <div className="md:w-2/12 w-1/3 text-xs text-start">Name</div>
            <div className="md:w-3/12 w-1/3 text-xs text-start">Start Date & Time</div>
            <div className="md:w-3/12 w-1/3 text-xs text-start">End Date & Time</div>
            <div className="md:w-1/12 w-1/3 text-xs text-start hidden md:flex">Status</div>
            {/* <div className="md:w-2/12 w-1/3 text-xs text-start hidden md:flex">Price</div> */}
          </div>

          <div className="w-full flex flex-col lg:overflow-y-auto h-full">
            {ticketList?.map((data: any, index: any) => (
              <div
                className="flex justify-between w-full text-[#444A6D] py-3 border-b border-[#EDF2F6]"
                key={index}
              >
                <div className="md:w-1/12 w-1/3 text-xs flex h-full">
                  <Button
                    appearance="primary"
                    size="sm"
                    className="!py-1 !text-[12px] !rounded"
                    onClick={() => {
                      setSelectedTicket(data?.ticket_id);
                      setIsOpenViewModal(true);
                    }}
                  >
                    View
                  </Button>
                </div>
                <div className="md:w-2/12 w-1/3 text-xs pt-1 justify-center items-center">
                  {data?.issue_timestamp
                    ? new Date(data.issue_timestamp)
                        .toLocaleString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                          timeZone: 'UTC', // Force UTC
                        })
                        .replace(',', '')
                    : '-'}
                </div>
                <div className="md:w-2/12 w-1/3 text-xs pt-1 ">{data?.ticket_name || `-`}</div>
                <div className="md:w-3/12 w-1/3 text-xs pt-1 md:flex hidden capitalize">
                  {data?.start_time
                    ? new Date(data.start_time)
                        .toLocaleString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                          timeZone: 'UTC', // Force UTC
                        })
                        .replace(',', '')
                    : '-'}
                </div>
                <div className="md:w-3/12 w-1/3 text-xs pt-1 md:flex hidden capitalize">
                  {data?.end_time
                    ? new Date(data.end_time)
                        .toLocaleString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                          timeZone: 'UTC', // Force UTC
                        })
                        .replace(',', '')
                    : '-'}
                </div>
                <div className="md:w-1/12 w-1/3 text-xs pt-1 md:flex hidden capitalize">
                  {data?.ticket_status || `-`}
                </div>
                {/* <div className="md:w-2/12 w-1/3 text-xs pt-1 hidden md:flex">
                  {data?.ticket_price || `-`}
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal isActive={isOpenViewModal} isHeaderShow={false} isFooterShow={false}>
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 mt-2">
            <i
              className="ri-close-line text-base text-[white] bg-[#7B1B67] rounded-full w-[20px] h-[20px] justify-center items-center flex"
              onClick={() => {
                setIsOpenViewModal(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="pt-1 text-2xl text-[#7B1B67] pb-3">Ticket ID</div>
            <div className="pt-1 text-2xl text-[#63717A] pb-6 font-black">{selectedTicket}</div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Tickets;
